import {
  type Actions,
  eActionTypes,
  type EstimationWizardState,
} from '@/context/estimationWizardContext/model.ts';

export const reducer = (state: EstimationWizardState, action: Actions): EstimationWizardState => {
  switch (action.type) {
    case eActionTypes.SET_ACTIVE_STEP:
      return {
        ...state,
        activeStep: action.payload,
      };
    case eActionTypes.SET_IS_WIZARD_VISIBLE:
      return {
        ...state,
        isActive: action.payload,
      };
    case eActionTypes.CANCEL_WIZARD:
      return {
        ...state,
        activeStep: [0, 0],
      };
    case eActionTypes.SET_WIZARD_STEPS:
      return {
        ...state,
        wizardSteps: action.payload,
      };
    default:
      return state;
  }
};
